"use client";

import type { ButtonProps } from "@ui/components/core/Button";

import { Button } from "@ui/components/core/Button";

import { useSTTGlobalSTT } from "../STTStore";
import { useSTTSelectedTabId } from "../STTStore";
import { useSTTTranslationCtx } from "../STTTranslations";
import clsx from "clsx";

export const OpenFileButton = ({
  openFileDialog,
  variant = "primary",
  className,
  size = "md",
}: {
  className?: string;
  openFileDialog: () => void;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
}) => {
  const t = useSTTTranslationCtx();
  // Use specific hooks instead of useSTTContext to minimize re-renders
  const globalSTT = useSTTGlobalSTT();
  const selectedTabId = useSTTSelectedTabId();

  return (
    <Button
      className={clsx("min-w-0 max-w-full flex-shrink", className)}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        // Don't clear selections - keep current tab/sample active
        openFileDialog();
      }}
      size={size}
      variant={variant}
    >
      {globalSTT.file && !selectedTabId ? (
        <span className='block truncate'>{globalSTT.file.name}</span>
      ) : (
        <>
          <span className='block truncate md:hidden'>{t("widget.cta.mobile")}</span>
          <span className='hidden truncate md:block'>{t("widget.cta.desktop")}</span>
        </>
      )}
    </Button>
  );
};
